export default {
  /**
   * 搜索参数对应的值
   * @param {String} name 键名
   * @returns
   */
  get: function (name) {
    const params = new URLSearchParams(location.search.substring(1));

    let content = '';

    params.forEach((value, key) => {
      if (key.toLowerCase() === name.toLowerCase()) {
        content = value;
      }
    });

    return content;
  },
  first: function (URLSearchParams) {
    var first = new Object();
    var i = 0;
    URLSearchParams.forEach((value, key) => {
      if (i === 0) {
        first[key] = value;
        i++;
      }
    });

    console.log('first', first);
    return first;
  },
  openFile: function (response) {
    let blob = new Blob([response.data], {
      type: 'application/pdf;charset=utf-8',
    });
    let downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    let contentDisposition = response.headers['content-disposition'];
    var patt = new RegExp('filename*=([^;]+\\.[^\\.;]+);*');
    var result = patt.exec(contentDisposition);
    var filename = decodeURI(result?.[1] || 'contract.pdf');
    downloadElement.style.display = 'none';
    downloadElement.href = href;
    downloadElement.download = filename;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
  },
  openFileforExcel: function (response, filename = 'contract.xlsx') {
    let downloadElement = document.createElement('a');
    downloadElement.style.display = 'none';

    let binaryData = [];
    binaryData.push(response.data);

    downloadElement.href = window.URL.createObjectURL(new Blob(binaryData));
    downloadElement.setAttribute('download', `${filename}.xlsx`);
    document.body.append(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
  },
};
